export const enLng = {
  common: {
    yes: 'Yes',
    no: 'No',
    or: 'or',
    all: 'All',
    from: 'from',
    to: 'to',
    today: 'Today',
    yesterday: 'Yesterday',
    basic: 'Basic',
    details: 'Details',
    noData: 'No Data',
    enabled: 'Enabled',
    notSet: 'Not Set',
    warning: 'Warning!',
    dropFiles: 'Drop your files here',
    selectedAccounts: 'Selected Users: {{count}}',

    interval: {
      '5sec': '5 seconds',
      '10sec': '10 seconds',
      '30sec': '30 seconds',
      '1min': '1 minute',
      '3min': '3 minutes',
    },

    forgotLinks: {
      gaNoAccess: 'I have no access to Google Authenticator',
      ga: 'Reset Google Authenticator and recovery codes',
      recoveryCodes: 'Lost your recovery codes?',
    },
  },

  header: {
    admins: 'Admins',
    users: 'Users',
    accounts: 'Accounts',
    dashboard: 'Dashboard',
    billing: 'Billing',
    recalculation: 'Recalculation',
    partnerSchemes: 'Partner Schemes',
    applications: 'Applications',
    vipApplications: 'VIP',
    betaTestApplications: 'Beta-testing',
    notifications: 'Notifications',
    banners: 'Banners',
    profile: 'Profile',

    menu: {
      user: {
        logout: 'Logout',
      },
    },
  },

  footer: {
    description: 'Technology brings infinite possibilities to the blockchain world',
    products: {
      title: 'Products',
      links: {
        app: 'APP',
        community: 'POW Community',
      },
    },

    support: {
      title: 'User support',
      links: {
        link1: 'Donec',
        link2: 'Mauris tellus sem',
        link3: 'Morbi pellentesque',
      },
    },

    partners: {
      title: 'Strategic partners',
      links: {
        link1: 'Etiam aliquam',
        link2: 'Lorem ipsum',
        link3: 'Curabitur rhoncus',
        link4: 'Etiam in volutpat ex',
      },
    },
  },

  page: {
    login: {
      title: 'Sign In',
      link: {
        forgotPassword: 'Forgot password?',
      },
    },

    forgotPassword: {
      title: 'Reset Password',
      result: {
        success: {
          title: 'Success!',
          description: 'Find link on your email and set new password',
        },
      },
    },

    newPassword: {
      title: {
        resetPassword: 'Reset Password',
        setPassword: 'Set Password',
      },

      result: {
        success: {
          title: 'Success!',
          description: 'Your password successfully updated',
        },

        error: {
          title: 'Error!',
          description: 'Your token is invalid or has expired',
        },
      },
    },

    notFound: {
      title: "Oops... We can't find this page",
      description: "It seems the page you're looking for is orphaned or wasn't mined yet.",
    },

    profile: {
      title: 'Profile',

      blocks: {
        basicInfo: {
          title: 'Basic Info',
        },

        accountSecurity: {
          title: 'Account Security',
        },
      },
    },

    main: {
      title: 'Enter username',
    },

    usersWithBtcHashrate: {
      title: 'Users with BTC hashrate',
    },

    vipApplications: {
      title: 'VIP Applications',
    },

    betaTestApplications: {
      title: 'Beta-testing Applications',
    },

    admins: {
      title: 'Admins',
    },

    billing: {
      title: 'Billing',
    },

    recalculation: {
      title: 'Recalculation',

      mode: {
        missingShares: 'Missing Shares',
        missingViaBTCPayment: 'Missing ViaBTC Payment',
      },

      noData: {
        title: 'No Data',
        desc: 'There is no information about recalculation. To get started click the button "New Recalculation"',
      },

      generalInfoBlock: {
        title: 'General Information',

        columns: {
          taskId: 'Task ID',
          type: 'Type',
          startDate: 'Start Date',
          endDate: 'End Date',
        },
      },

      dryRunBlock: {
        title: 'Dry Run',

        columns: {
          status: 'Status',
          incorrectPaymentsNumber: 'Incorrect Payments Number',
          incorrectPaymentsTotalNumber: 'Incorrect Payments Total',
          correctPaymentsNumber: 'Correct Payments Number',
          correctPaymentsTotalNumber: 'Correct Payments Total',
        },

        message: {
          pending: {
            title: 'Dry run is being processed',
            desc: 'Please wait, It may take a while',
          },

          error: {
            title: 'Dry run failed with error',
          },
        },
      },

      hardRunBlock: {
        title: 'Hard Run',

        message: {
          success: {
            title: 'Success',
            desc: 'Hard run task sent!',
          },

          pending: {
            title: 'Hard run is being processed',
            desc: 'Please wait, It may take a while',
          },

          error: {
            title: 'Hard run failed with error',
          },
        },
      },
    },

    partnerSchemes: {
      title: 'Partner Schemes',
    },

    partnerSchemeDetails: {
      title: 'Partner Scheme Details',

      navigation: {
        partnerSchemes: 'Partner schemes',
      },

      info: {
        name: 'Name',
        logs: 'Logs',
        expirationDate: 'Expiration Date',
        registrationLink: 'Registration Link',
      },
    },

    partnerSchemeLogs: {
      title: 'Partner Scheme Logs',
    },

    notifications: {
      title: 'New Notification',

      type: {
        closable: 'Closable',
        nonClosable: 'Unclosable',
      },

      destination: {
        toast: 'Toast',
        email: 'E-mail',
        telegram: 'Telegram',
      },

      recipients: {
        allUsers: 'All Users',
        activeUsers: 'Active Users',
        userIds: 'Specific Users',
      },
    },

    banners: {
      title: 'Banners',
    },

    dashboard: {
      title: 'Dashboard',

      level: {
        pool: 'Pool',
        user: 'User',
        account: 'Account',
      },

      tooltip: {
        user: "To check individual user's statistics, select them from the list. To go back to the pool statistics, simply clear the selection.",
        account:
          "To check individual sub-account's statistics, select them from the list. To go back to the user statistics, simply clear the selection.",
      },

      blocks: {
        network: {
          title: 'Network Summary',

          items: {
            coinPrice: 'Bitcoin price',
            networkHashrate: 'Network hashrate',
            networkDifficulty: 'Network difficulty',
          },
        },

        allAccounts: {
          title: 'All accounts',

          items: {
            balance: 'Balance',
            hashrate: 'Hashrate (24h)',
            workers: 'Workers',
          },

          workersStatus: {
            active: 'Active Workers',
            inactive: 'Inactive Workers',
            offline: 'Offline Workers',
          },
        },

        balance: {
          title: 'Balance',

          items: {
            lastRevenue: 'Last 24-Hour Revenue ({{coin}})',
            totalIncome: 'Total Income ({{coin}})',
          },
        },

        hashrate: {
          title: 'Hashrate',

          items: {
            oneHour: '1 Hour Average',
            oneDay: '1 Day Average',
          },
        },

        workers: {
          title: 'Workers',

          items: {
            active: 'Active',
            inactive: 'Inactive',
            offline: 'Offline',
          },

          tooltip: {
            activeWorkers: 'At least 1 share sent within the last hour',
            inactiveWorkers: 'No shares for more than 1 hour',
            offlineWorkers: 'No shares for more than 24 hour',
          },
        },

        incomeChart: {
          title: 'Income Chart',

          legend: {
            incomePerDay: 'Income per Day',
          },
        },

        hashrateChart: {
          title: 'Hashrate Chart',

          legend: {
            hashRate: 'Hashrate',
            rejectRate: 'Reject Rate',
          },
        },

        incomeDetails: {
          title: 'Income Details',

          columns: {
            date: 'Date (UTC)',
            hashrate: 'Hashrate',
            rejectRate: 'Reject Rate',
            totalEarning: 'Total Income',
            unitOutput: '24h Unit Output (per TH/s)',
            actions: 'Actions',
          },
        },
      },
    },

    users: {
      title: 'Users',
    },

    accounts: {
      title: 'Accounts',
    },
  },

  form: {
    label: {
      username: 'Username',
      email: 'E-mail',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      totp: 'Google Authenticator token',
      otp: 'Recovery code',
      roles: 'Roles',
      scheme: 'Scheme',
      name: 'Name',
      poolComission: 'Pool Commission (%)',
      poolFee: 'Pool Fee',
      accountFee: 'Account Fee (%)',
      totalFee: 'Total Fee',
      applyToAllAccounts: 'Apply to all accounts',
      beneficiaries: 'Benefeciaries',
      account: 'Account',
      comission: 'Commission (%)',
      totalComission: 'Total Commission',
      pplnsFee: 'PPLNS Fee (%)',
      pool: 'Pool',
      PpsBenefeciaries: 'PPS Benefeciaries',
      PplnsBenefeciaries: 'PPLNS Benefeciaries',
      ppsCommission: 'PPS Commission',
      pplnsCommission: 'PPLNS Commission',
      expirationDate: 'Expiration Date',
      inheritFromScheme: 'Inherit from Scheme',
      newSchemeName: 'New Scheme Name',
      mode: 'Mode',
      startDate: 'Start Date',
      endDate: 'End Date',
      accessLevels: 'Access Levels',
      limit: 'Limit',
      text: 'Text',
      type: 'Type',
      destinations: 'Destinations',
      recipients: 'Recipients',
      user: 'User',
      users: 'Users',
      subaccount: 'Sub-account',
      file: 'File',
      link: 'Link',
      note: 'Note',
      altText: 'Alt Text',
      active: 'Activation',
      signInPassword: 'Sign In Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm new password',
      authenticator: 'Two-Factor Authentication',
      gaCode: 'Google Authenticator code',
      recoveryCode: 'Recovery code',
    },

    button: {
      ok: 'OK',
      search: 'Search',
      reset: 'Reset',
      change: 'Change',
      changeEmail: 'Change email',
      signIn: 'Sign In',
      logIn: 'Log In',
      sendLink: 'Send Link',
      create: 'Create',
      restartPplns: 'Restart PPLNS',
      restartPps: 'Restart PPS',
      restartRef: 'Restart REF',
      submit: 'Submit',
      confirm: 'Confirm',
      cancel: 'Cancel',
      newScheme: 'New Scheme',
      addBeneficiary: 'Add Benefeciary',
      goBack: 'Go Back',
      newRecalculation: 'New Recalculation',
      refresh: 'Refresh',
      autorefresh: 'Autorefresh',
      startHardRun: 'Start Hard Run',
      newBanner: 'New Banner',
      newAdmin: 'New Admin',
      browse: 'Browse',
      edit: 'Edit',
      next: 'Next',
      copy: 'Copy',

      appStore: {
        title: 'Download on the',
        platform: 'App Store',
      },

      googlePlay: {
        title: 'GET IT ON',
        platform: 'Google Play',
      },
    },

    placeholder: {
      searchAndSelect: 'Search and select...',
      searchAndSelectUser: 'Search and select user from dropdown...',
      searchAndSelectAccount: 'Search and select account from dropdown...',
    },

    title: {
      scanGaQr: 'Scan QR code via Google Authenticator',
    },
  },

  tooltip: {
    edit: 'Edit',
    remove: 'Remove',
    inherit: 'Inherit',
    details: 'Details',
    defaultScheme: 'Default',
    commissionCreditedToPool: 'All commission is credited to the pool',
    moveToAnotherScheme: 'Move to another scheme',
    logs: 'Show Logs',
    partnerSchemeDeleted: 'Deleted',
    copied: 'Copied',
    copy: 'Copy',
    show: 'Show',
    userDashboard: 'Show User Dashboard',
    accountDashboard: 'Show Account Dashboard',
    mainAccountDashboard: 'Show Main Account Dashboard',
    changeFee: 'Change Fee',
    changeFees: 'Change Fees',
    accountsTotalFeeColumn: 'The total fee is the sum of the pool fee and the account fee',
    userAccountsList: "Show User's Accounts List",
    expand: 'Expand',
    copyRow: 'Copy row',
  },

  user: {
    info: {
      ga: {
        installed: 'Installed',
        notInstalled: 'Not installed',
      },

      status: {
        active: 'Active',
        blocked: 'Blocked',
      },
    },

    history: {
      status: {
        success: 'Success',
        inProgress: 'In Progress',
        failure: 'Failure',
      },

      action: {
        login1fa: 'Login 1FA',
        login2fa: 'Login 2FA',
        loginOtp: 'Login OTP',
        passwordReset: 'Password Reset',
        passwordChange: 'Password Change',
        emailChange: 'E-mail Change',
        walletChange: 'Wallet Change',
        payPasswordChange: 'Payment Password Change',
        payPasswordReset: 'Payment Password Reset',
        payPasswordWrong: 'Wrong Payment Password',
      },
    },
  },

  admin: {
    role: {
      rootAdmin: 'Root Admin',
      admin: 'Admin',
    },
  },

  modal: {
    partnerSchemes: {
      editScheme: {
        title: 'Partner Scheme',
      },

      deleteScheme: {
        title: 'Delete Scheme',
        desc: 'Are you sure you want to delete scheme "{{name}}"?',
        warning:
          '{{count}} users are associated with the scheme. After deletion users will be transferred to the default scheme',
      },
    },

    editPplns: {
      title: 'Edit PPLNS Fee',
    },

    editPartnerScheme: {
      title: 'Edit Partner Scheme',
      usersCount: 'Selected users number',
    },

    chooseScheme: {
      title: 'Choose Partner Scheme',
    },

    confirmRecovery: {
      title: 'Confirm Recovery',
      desc: 'These buttons restart the billing process in RECOVERY mode. Please double-check the integrity of the billing data (hashrate, shares, incoming payments) before starting the recovery billing process.',
    },

    newRecalculation: {
      title: 'New Recalculation',
    },

    confirmEnableApi: {
      title: 'Enable API',
      desc: 'Please choose access levels to enable API for this user',
    },

    confirmDisableApi: {
      title: 'Disable API',
      desc: 'Are you sure you want to disable API for this user?',
    },

    changeAccessLevels: {
      title: 'Change API Access Levels',
    },

    changeApiKeysLimit: {
      title: 'Change API Keys Limit',
    },

    changeAccountFee: {
      title: 'Change Fee ({{accountName}})',
      infoMessage: 'Effective rate will apply from the next day (UTC).',
    },

    changeUserAccountsFees: {
      title: 'Change Accounts Fees',
      infoMessage: 'Effective rate will apply from the next day (UTC).',
      applyToAllMessage: 'This fee will be applied to all user accounts.',
    },

    createBanner: {
      title: 'New Banner',
    },

    createAdmin: {
      title: 'Create Admin',
    },

    cropImage: {
      title: 'Crop Image',
    },

    editBanner: {
      title: 'Edit Banner',
    },

    deleteBanner: {
      title: 'Delete Banner',
      desc: 'Are you sure you want to delete this banner?',
    },

    signInPassword: {
      title: 'Set Up Sign In Password',

      steps: {
        password: 'Password',
        auth: 'Authentication',
        completed: 'Done',
      },
    },

    twoFAEnable: {
      title: 'Enable two-factor authentication',

      steps: {
        downloadApp: 'Download the app',
        securityCheck: 'Bind the account',
        boundSuccessfulley: 'Done',
      },

      formSteps: {
        downloadApp: 'If you do not have the Google Authenticator app please install it on your device. ',
        scanBarcode: 'Open the Google Authenticator application and scan the QR-code:',
        enterKey: 'If you unable to scan enter the key:',
        enterCode: 'Enter the code provided by the application and click "Submit" to finish the setup.',
      },

      button: {
        unableToScan: 'Unable to scan?',
        scanQrCode: 'Scan QR-code?',
      },

      codes: {
        text: 'These are your recovery codes which will act as a one-time substitute to the GA code in case you loose access to your Google Authenticator app. Please store them safely offline or on a separate device. Each code can only be used once.',
      },
    },

    twoFADisable: {
      title: 'Disable Google Authenticator',
    },
  },

  table: {
    userGeneralInfo: {
      title: 'General Information',
      columns: {
        id: 'ID',
        account: 'Account',
        note: 'Note',
        customerRecords: 'Сustomer records',
        subAccounts: 'Sub accounts',
        referrals: 'Referrals',
        referralGroups: 'Referral groups',
        email: 'Email',
        mobilePhone: 'Mobile phone',
        ga: 'GA',
        twoFactorAuthentication: '2FA',
        paymentPassword: 'Payment password',
        registrationDate: 'Registration Date',
        blackList: 'Black List',
        logHistory: 'Log history',
        messages: 'Messages',
        developerChangelog: 'Developer changelog',
        employeeActivityLog: 'Employee activity log',
        userActivityLog: 'User activity log',
        whiteList: 'White List',
        underControl: 'Under control',
        fundsWithdrawal: 'Funds withdrawal',
        partnerScheme: 'Partner Scheme',
        status: 'Status',
        riskIndicator: 'Risk indicator',
        securitySurveillance: 'Security surveillance',
        adminWatcherLink: 'Admins Watcher Link',
        watcherLink: 'Watcher Link',
      },
    },

    btcMining: {
      title: 'BTC Mining',
      columns: {
        subAccounts: 'Sub accounts',
        dedicatedAddress: 'Dedicated Address',
        linkReferral: 'Link referral',
        individualReferral: 'Individual referral',
        btcAddress: 'BTC Address',
        btcAutoPayoutAddress: 'BTC Auto Payout Address',
        btcBlackList: 'BTC Black List',
        autoWithdrawal: 'Auto Withdrawal',
        minimalLimitforAutoWithdrawal: 'Minimal Limit for Auto Withdrawal',
        rewardType: 'Reward Type',
        partnerScheme: 'Partner Scheme',
        poolFeePPS: 'Pool Fee PPS',
        poolFeePplns: 'Pool Fee PPLNS',
        poolFeeSolo: 'Pool Fee SOLO',
        PpsFee: 'PPS Fee',
        PplnsFee: 'PPLNS Fee',
        activeWorkers: 'Active Workers',
        offlineWorkers: 'Offline Workers',
        inactiveWorkers: 'Inactive Workers',
        BtcHashrate: 'BTC Hashrate',
        totalHashrate: 'Total Hashrate',
        miningInformation: 'Mining Information',
        expectedBlocksForMainAccount: 'Expected blocks for main account',
        blocksMinedByMainAccount: 'Blocks mined by main account',
        mainAccountLuck: 'Main account luck',
        cts: 'CTS (%)',
        daylyProfit: '24h Profit',
        totalProfit: 'Total Profit',
        profitDistribution: 'Profit Distribution',
        allAccountsProfitReport: 'All Accounts Profit Report',
        blocksMined: 'Blocks mined (Total / 7 / 30 / 90 days)',
        expectedBlocks: 'Expected blocks (Total / 7 / 30 / 90 days)',
        luck: 'Luck (Total / 7 / 30 / 90 days)',
        trust: 'Trust % (Total / 7 / 30 / 90 days)',
        totalBtcMined: 'Total BTC mined',
        blackListIp: 'Black List IP',
      },
    },

    accountWallet: {
      title: 'Account Wallet',
      columns: {
        balance: 'Balance',
        blocked: 'Blocked',
        paid: 'Paid',
        deposit: 'Deposit',
        manualWithdrawal: 'Manual Withdrawal',
        usdAmount: 'USD Amount',
      },
    },

    apiManagement: {
      title: 'API Management',

      columns: {
        enabled: 'Enabled',
        accessLevels: 'Access Levels',
        limit: 'API Keys Limit',
        apiKeys: 'API Keys',
      },
    },

    apiKeys: {
      title: 'API Keys',

      columns: {
        apiKey: 'API Key',
        accessLevel: 'Access Level',
        note: 'Note',
      },
    },

    userHistory: {
      title: 'History',

      columns: {
        action: 'Action',
        status: 'Status',
        browser: 'Browser',
        device: 'Device',
        ip: 'IP',
        message: 'Message',
        eventTimestamp: 'Time',
      },

      filter: {
        action: {
          title: 'Action',
        },
      },
    },

    vipApplications: {
      columns: {
        createdDate: 'Created Date',
        email: 'E-mail',
        name: 'Contact',
        country: 'Country or Region',
        company: 'Company Name',
        telegram: 'Telegram',
        mobile: 'Phone',
        message: 'Message',
      },
    },

    betaTestApplications: {
      columns: {
        createdDate: 'Created Date',
        email: 'E-mail',
        name: 'Contact',
        country: 'Country or Region',
        company: 'Company Name',
        telegram: 'Telegram',
        mobile: 'Phone',
        message: 'Message',
      },
    },

    partnerSchemes: {
      columns: {
        name: 'Name',
        pps: 'PPS',
        pplns: 'PPLNS',
        poolComission: 'Pool Commission',
        beneficiaries: 'Benefeciaries',
        totalComission: 'Total Commission',
        link: 'Link',
        expirationDate: 'Expiration Date',
        status: 'Status',
        type: 'Type',
        actions: 'Actions',
      },

      emptyColumns: {
        beneficiaries: 'No Benefeciaries',
        expirationDate: 'No Expiration Date',
      },

      filter: {
        status: {
          title: 'Status',

          items: {
            active: 'Active',
            expired: 'Expired',
            deleted: 'Removed',
          },
        },

        type: {
          title: 'Type',

          items: {
            default: 'Default',
            referral: 'Referral',
            referralAmbassador: 'Ambassador',
            referralPartner: 'Partner',
          },
        },
      },
    },

    partnerSchemeUsers: {
      columns: {
        id: 'ID',
        username: 'Username',
        email: 'E-mail',
        actions: 'Actions',
      },

      menu: {
        title: 'Actions',

        items: {
          changeUserScheme: 'Move to Another Scheme',
          editScheme: 'Edit Scheme',
          removeScheme: 'Remove Scheme',
        },
      },
    },

    partnerSchemeLogs: {
      columns: {
        date: 'Date',
        initiator: 'Initiator',
        changes: 'Changes',
      },

      fields: {
        name: 'Name',
        link: 'Link',
        expirationDate: 'Expiration Date',
        isDefault: 'Default',
        status: 'Status',
        beneficiaries: 'Benefeciaries',
        ppsBeneficiaries: 'PPS Commission',
        ppsPoolCommission: 'PPS Pool Commission',
        ppsTotalCommission: 'PPS Total Commission',
        pplnsBeneficiaries: 'PPLNS Commission',
        pplnsPoolCommission: 'PPLNS Pool Commission',
        pplnsTotalCommission: 'PPLNS Total Commission',
      },
    },

    banners: {
      columns: {
        preview: 'Preview',
        note: 'Note',
        link: 'Link',
        createdDate: 'Created Date',
        updatedDate: 'Updated Date',
        status: 'Status',
        altText: 'Alt Text',
        actions: 'Actions',
      },
    },

    users: {
      columns: {
        uid: 'User ID',
        aid: 'Account ID',
        username: 'Username',
        accountName: 'Account Name',
        email: 'E-mail',
        mobile: 'Mobile',
        totalFee: 'Total Fee',
        actions: 'Actions',
      },
    },

    userAccountsFees: {
      columns: {
        accountId: 'Account ID',
        accountName: 'Account Name',
        poolFee: 'Pool Fee (%)',
        accountFee: 'Account Fee (%)',
        totalCommission: 'Total Fee (%)',
      },
    },

    admins: {
      columns: {
        username: 'Username',
        email: 'E-mail',
        roles: 'Roles',
        is2fa: '2FA',
        status: 'Status',
      },
    },

    paymentSettings: {
      columns: {
        coin: 'Coin',
        wallet: 'Wallet',
        autoWithdrawal: 'Auto Withdrawal',
        autoWithdrawalThreshold: 'Auto Withdrawal Threshold',
        autoInternalTransfer: 'Auto Internal Transfer',
        autoInternalTransferAccounts: 'Auto Internal Transfer Accounts',
      },
    },
  },

  notification: {
    internal: {
      noInternet: 'No internet connection. Please check your connection and reload the page',
      externalResourcesFailed: 'An error occurred loading third-party resources. Please reload page.',
    },
    accountFeeUpdated: 'Account fee has been updated successfully',
    userAccountsFeesUpdated: 'User accounts fees have been updated successfully',
    failedToLoadAccountsFees: 'Failed to load accounts fees',
  },

  validation: {
    required: 'This field is required',
    digitsOnly: 'Must contain digits only',
    hasUpperCase: 'Uppercase letters',
    hasLowerCase: 'Lowercase letters',
    hasNumber: 'Numbers',
    hasSpecialChar: 'Special characters',
    franctionalNumbers: 'Must be numeric',
    duplicateAccounts: 'Accounts must be unique',
    totalFeeExceeds: 'Total fee cannot exceed {{max}}%',
    minNumber: 'Must be greater than {{min}}',
    minNumberEqual: 'Must be greater than or equal to {{min}}',
    minLenght: 'Must contain at least {{min}} characters',
    maxLenght: 'Must contain a maximum of {{max}} characters',

    email: {
      notValid: 'E-mail is not valid',
    },

    password: {
      length: 'Length 12-32',
      mustMatch: 'Passwords do not match',
    },

    ga: {
      length: 'Length must be equal to 6',
    },
  },

  status: {
    partnerScheme: {
      active: 'Active',
      expired: 'Expired',
      deleted: 'Removed',
    },

    recalculation: {
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed',
    },

    accessLevel: {
      public: 'Public',
      private: 'Private',
      signature: 'Signature',
    },

    banner: {
      active: 'Active',
      inactive: 'Inactive',
    },

    admin: {
      active: 'Active',
      inactive: 'Inactive',
    },

    paymentSettings: {
      enabled: 'On',
      disabled: 'Off',
    },
  },

  success: {
    createAdmin: 'Admin created successfully',
    createNotification: 'Notification created successfully',
    restart: 'Billing restart order sent',
    changePplns: 'PPLNS fee changed sucessfully',
    changePartnerScheme: 'Partner scheme changed sucessfully',
    benefeciaryMovedToAnotherScheme: 'Benefeciary moved to another scheme successfully',
    editPartnerScheme: 'Partner scheme updated successfully',
    createPartnerScheme: 'Partner scheme created successfully',
    deletePartnerScheme: 'Partner scheme removed successfully',
    changeScheme: 'Users transferred to another scheme successfully',
    startNewRecalculation: 'Recalculation started successfully',
    passwordChangeSuccess: 'Password changed successfully',
    twoFaEnabled: 'Success. Two-factor authentication enabled.',
    twoFaDisabled: 'Success. Two-factor authentication disabled.',
  },

  error: {
    auth: {
      unauthorized: 'You are not authorized',
      forbidden: 'Forbidden',
      invalidData: 'Invalid credentials',
      invalidAdminData: 'Invalid E-mail or Username',
      emptyData: 'Provide Email or Password!',
    },

    files: {
      fileInvalidType: 'Invalid file type',
    },

    common: {
      serverIsNotResponding: 'Server is not responding',
      pageNotFound: 'Page not found',
      badRequest: 'Bad request',
      unknown: 'Something went wrong.',
      copy: 'Not copied. Please refresh the page and try again.',
    },

    captcha: {
      verification: {
        title: 'CAPTCHA Verification Failed',
        desc: 'We were unable to verify your login attempt due to an unsuccessful CAPTCHA verification. This may have been caused by unusual activity or an automated process.<br></br>Please try the following:<ul><li>Double-check that you have correctly completed the CAPTCHA.</li><li>Clear your browser cache and cookies, then try again.</li><li>Use a different browser or device if the issue persists.</li></ul> <br></br> If you continue to experience difficulties, please contact our support team at <Link>support@superpool.com</Link> for further assistance.<br></br><br></br>Thank you for your understanding and cooperation.',
      },

      network: {
        title: 'Network Error',
        desc: 'We were unable to verify your login attempt due to an unsuccessful CAPTCHA verification due to a network error.<br></br>  If you continue to experience difficulties, please contact our support team at <Link>support@superpool.com</Link> for further assistance.<br></br><br></br>Thank you for your understanding and cooperation.',
      },

      javascript: {
        title: 'CAPTCHA Verification Failed',
        desc: 'We were unable to verify your login attempt due to an unsuccessful CAPTCHA verification. This may have been caused by unusual activity or an automated process.<br></br>Please try the following:<ul><li>Double-check that you have correctly completed the CAPTCHA.</li><li>Clear your browser cache and cookies, then try again.</li><li>Use a different browser or device if the issue persists.</li></ul> <br></br> If you continue to experience difficulties, please contact our support team at <Link>support@superpool.com</Link> for further assistance.<br></br><br></br>Thank you for your understanding and cooperation.',
      },
    },

    emailAlreadyRegistered: 'This email is already registered',
    incorrectTOTP: 'Error. Invalid credentials',
    incorrectPassword: 'Error. Invalid credentials',
    incorrectExistingPassword: 'Error. Invalid credentials',
    invalidCredentials: 'Error. Invalid credentials',
    invalidParameterValue: 'Error. Invalid values',
  },
};
